import Page404 from "app/not-found";
import "../../styles/styles.css"
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PageAdmin = () => {
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.user);

    const profil = () => navigate("profil");
    const gestionUsagers = () => navigate("gestionUsagers");
    const ajouterArticle = () => navigate("ajouterArticle");
    const ajouterProjet = () => navigate("ajouterProjet");
    const listeProjets = () => navigate("listeProjets");
    const modifierArticle = () => navigate("modifierArticle");
    const creerInfolettre = () => navigate("creerInfolettre");
    const ajouterInfolettre = () => navigate("ajouterInfolettre");
    const envoyerInfolettre = () => navigate("envoyerInfolettre");
    const ajouterVideo = () => navigate("ajouterVideo");
    const ajouterEvenement = () => navigate("/ajouterEvenement"); // 🆕
    const supprimerEvenement = () => navigate("/supprimerEvenement"); // 🆕

    if (!user) return <Page404 />;

    return (
        <>
            <div className="container mx-auto flex flex-col items-center ">
                <h2 className="text-center inline-block align-middle text-2xl font-semibold md:text-3xl">
                    Administration
                </h2>
                <br /><br />
                <div>
                    <button className="boutonDownload" onClick={profil}>Profil</button>
                </div>
                <br />

                {user.role === "admin" && (
                    <>
                        <div>
                            <button className="boutonDownload" onClick={gestionUsagers}>Gestion usagers</button>
                        </div>
                        <br />
                    </>
                )}

                {(user.role === "admin" || user.role === "editor") && (
                    <>
                        <div>
                            <button className="boutonDownload" onClick={ajouterArticle}>Ajouter Article</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={modifierArticle}>Modifier Article</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={creerInfolettre}>Créer Infolettre</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={ajouterInfolettre}>Ajouter Infolettre</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={envoyerInfolettre}>Envoyer Infolettre</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={ajouterVideo}>Ajouter Vidéo</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={ajouterEvenement}>Ajouter Événement</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={supprimerEvenement}>Supprimer Événement</button>
                        </div>
                        <br />
                    </>
                )}
                {(user.role === "admin" || user.role === "editor" || user.role === "membre") && (
                    <>
                        <div>
                            <button className="boutonDownload" onClick={listeProjets}>Liste des projets</button>
                        </div>
                        <br />
                        <div>
                            <button className="boutonDownload" onClick={ajouterProjet}>Ajouter un projet</button>
                        </div>
                      </>
                )}
                <br /><br />
            </div>
        </>
    );
};

export default PageAdmin;
